import List from './components/List'
import Form from './components/Form'

export default [
  {path: '/state', component: List, name: 'state.index'},
  {path: '/state/store', component: Form, name: 'state.store'},
  {path: '/state/:id', component: Form, name: 'state.update'}
]



// WEBPACK FOOTER //
// ./src/app/domains/state/routes.js